import { useQuery } from '@tanstack/react-query';
import ResourceService from '../Services/resources/ResourceService';

export const GET_RESOURCES_QUERY_KEY = 'getResources';
export const SHOW_RESOURCE_DETAILS_QUERY_KEY = 'showResourceDetails';

export const useGetResources = (chapterId) => {
  return useQuery({
    queryKey: [GET_RESOURCES_QUERY_KEY, chapterId],
    queryFn: () => ResourceService.getPdfFilesByChapter(chapterId),
  });
};

export const useShowResourceDetails = (pdfFileId) => {
  return useQuery({
    queryKey: [SHOW_RESOURCE_DETAILS_QUERY_KEY, pdfFileId],
    queryFn: () => ResourceService.streamPdfFile(pdfFileId),
  });
};